<template>
  <v-card
    style="width: 100% !important; height: 40%; min-height: 40% !important"
  >
    <v-row no-gutters>
      <v-col cols="12">
        <div class="amchartDiv" ref="chartdiv"></div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_frozen from "@amcharts/amcharts4/themes/frozen";
import { mapState } from "vuex";

am4core.useTheme(am4themes_frozen);

export default {
  name: "LogChart",

  data() {
    return {
      setupDone: false,
      chart: null,
      noData: false,
      lastId: null
    };
  },

  mounted() {
    this.setupDone = false;
    this.setUpChart();
  },

  beforeDestroy() {
    if (this.chart !== null) {
      this.chart.dispose();
    }
  },

  methods: {
    setUpChart() {
      var ref = this.$refs.chartdiv;
      if (ref === undefined) return;

      // Create the chart
      let chart = am4core.create(ref, am4charts.XYChart);
      chart.paddingRight = 20;

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.tooltip.disabled = true;
      valueAxis.renderer.minWidth = 35;

      let series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.dateX = "date";
      series.dataFields.valueY = "value";

      series.tooltipText = "{valueY.value}";
      chart.cursor = new am4charts.XYCursor();

      series.fillOpacity = 1;

      var fillModifier = new am4core.LinearGradientModifier();
      fillModifier.opacities = [1, 0];
      fillModifier.offsets = [0, 1];
      fillModifier.gradient.rotation = 90;
      series.segments.template.fillModifier = fillModifier;

      this.chart = chart;
      this.chart.data = [];

      let c = 0;
      for (let i = this.logs.length - 1; i > 0; i--) {
        this.chart.addData({
          value: c,
          date: new Date(this.logs[i].createdAt)
        });
        c++;
      }

      this.setupDone = true;
    },

    idExist(id, arr) {
      if (id === null) return false;

      return id === arr[0].logId ? true : false;
    }
  },

  computed: {
    ...mapState("logs", ["logs", "lastRequestLogs"])
  },

  components: {},

  watch: {
    lastRequestLogs(val) {
      if (this.setupDone && !this.idExist(this.lastId, val)) {
        val.forEach((e, i) => {
          this.chart.addData({
            value: this.logs.length + i + 1,
            date: new Date(e.createdAt)
          });
        });
      }
    }
  }
};
</script>

<style scoped>
.amchartDiv {
  height: 320px;
}
</style>
